/**
 * **Busy Rooms**
 *
 * @exports partnership_240
 * @category partnerships
 */
function factory({ window, document, thn }) {

  const partnership = {};

  // Check if it is a brand
  partnership.isBrand = function isBrandgetId(hostname) {
    return !!hostname.match(/originalirishhotels/);
  };

  /**
       * @memberOf module:partnership_240
       */
  partnership.getId = function getId() {
    return '240';
  };

  /**
       * @memberOf module:partnership_240
       */
  partnership.check = function check() {
    // Check if we are in the BE of Busy Rooms
    return window.location.hostname.includes('direct-reservation');
  };

  /**
       * @memberOf module:partnership_240
       */
  partnership.getSiteId = function getSiteId() {

    const hostname = window.location.hostname;
    const hotelName = document.querySelector('.hotel_description_name')?.textContent?.replace(/\*/g, '')?.trim() || window?.$IBE_hotelName || document.querySelector('[id^=ddHotels]>option[selected="selected"]')?.textContent;
    const hotelId = partnership.isBrand(hostname) ? hotelName : window.location.hostname.split('.')[0].replace(/^m-/, '');
    const result = {
      externalId: hotelId || '',
    };
    return result;
  };

  return partnership;
}

export { factory };
